import React from 'react';

import {Logo} from '../Logo';
import {SidebarNavigation} from '../Navigation';

import {SidebarContainer, LogoContainer, NavContainer} from './styled';

export function MainSidebar() {
    return (
        <SidebarContainer>
            <LogoContainer>
                <Logo />
            </LogoContainer>
            <NavContainer>
                <SidebarNavigation />
            </NavContainer>
        </SidebarContainer>
    );
}
